import React from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/react-hooks';
import { Typography } from '@material-ui/core';
import { getFer } from './apiQueries';
import FerDetails from './FerDetails';
import { Fer as FerType } from '../../utils/types';

export const Fer: React.FC = () => {
	const { gameId, ferId }: FerParams = useParams();
	const { loading, error, data, refetch } = useQuery<FerQueryResponse, FerParams>(getFer, {
		variables: { ferId: ferId, gameId: gameId },
		fetchPolicy: 'no-cache'
	});

	if (loading) return <Typography>Loading...</Typography>;
	if (error) return <Typography>Error loading data from the server</Typography>;
	if (!data?.getFer) return <Typography>No Fer found</Typography>;

	const { channelId, startTime, endpoint, endTime, channel, available } = data.getFer;

	return (
		<FerDetails
			__typename='fer'
			ferId={ferId}
			channelId={channelId}
			available={available}
			gameId={gameId}
			startTime={startTime}
			endTime={endTime}
			endpoint={endpoint}
			channel={channel}
			refetchFerDetails={refetch}
		/>
	);
};

type FerParams = {
	ferId: string;
	gameId: string;
};

type FerQueryResponse = {
	getFer: FerType;
};

export default Fer;
